var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "orbit-spinner", style: _vm.spinnerStyle }, [
    _c("div", { staticClass: "orbit one", style: _vm.orbitStyle }),
    _vm._v(" "),
    _c("div", { staticClass: "orbit two", style: _vm.orbitStyle }),
    _vm._v(" "),
    _c("div", { staticClass: "orbit three", style: _vm.orbitStyle }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }